import { render } from "./Grend2.vue?vue&type=template&id=16e5efd8&bindings={}"
import script from "./Grend2.vue?vue&type=script&lang=js"
export * from "./Grend2.vue?vue&type=script&lang=js"

import "./Grend2.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script